import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import {
  provideTransloco,
  Translation,
  TRANSLOCO_LOADING_TEMPLATE,
  TRANSLOCO_SCOPE,
  TranslocoLoader,
} from '@jsverse/transloco';
import { provideTranslocoPersistTranslations } from '@jsverse/transloco-persist-translations';
import localForage from 'localforage';
import { environment } from '../../../environments/environment';

const translationStorage = localForage.createInstance({
  driver: localForage.INDEXEDDB,
  name: 'nft-folks-translations',
  storeName: 'translations',
});

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

const TRANSLATION_TTL = 1000 * 60 * 5; // 5 min

@NgModule({
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en'],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: environment.production,
        missingHandler: {
          // It will use the first language set in the `fallbackLang` property
          useFallbackTranslation: true,
        },
      },
      loader: TranslocoHttpLoader,
    }),
    { provide: TRANSLOCO_SCOPE, useValue: { scope: 'global' }, multi: true },
    { provide: TRANSLOCO_SCOPE, useValue: { scope: 'error' }, multi: true },
    { provide: TRANSLOCO_SCOPE, useValue: { scope: 'alert' }, multi: true },
    provideTranslocoPersistTranslations({
      loader: TranslocoHttpLoader,
      storage: { useValue: translationStorage },
      storageKey: 'nft-folks-translations',
      ttl: environment.production ? TRANSLATION_TTL : 0,
    }),
    {
      provide: TRANSLOCO_LOADING_TEMPLATE,
      useValue: '<p>Loading translation files...</p>',
    },
  ],
})
export class TranslocoRootModule {}
